export function showLocaleNoticeSelector(state) {
    return state.legalDocumentLocale === 'es_ES';
}

export function legalDocumentIsLoadedSelector(state) {
    return state.legalDocumentIsLoaded ?? false;
}
